import * as React from 'react';

import { AbacusCurrency } from '@Shared/helpers';
import { formatDate } from '@Shared/helpers/abacusTimeFormatter';

import * as style from './CardTransactionRow.styl';

interface ICardTransactionRowProps {
  transactionId: string;
  cardHolderName?: string;
  avatarUrl?: string;
  amount: number;
  merchant: string;
  dateMilliseconds: number;
  isSelected?: boolean;
  flagDuplicate?: boolean;
}

function renderAvatar(avatarUrl: string) {
  return (
    <div className="circle-img">
      <img src={avatarUrl} />
    </div>
  );
}

function renderAmount(amount: number) {
  // this can be replaced by .toFormattedString and removing the math.abs later when I'm not doing broad refactors
  const dollarAmount = new AbacusCurrency(Math.abs(amount)).getUnitValue();
  if (amount < 0) {
    return <div className="transaction-amount credit">-${dollarAmount}</div>;
  }
  return <div className="transaction-amount debit">${dollarAmount}</div>;
}

export const CardTransactionRow: React.FC<ICardTransactionRowProps> = (props) => {
  const { cardHolderName, avatarUrl, amount, merchant, dateMilliseconds, flagDuplicate } = props;

  const date = formatDate(dateMilliseconds, 'PP');

  const name = cardHolderName || 'Unassigned';
  const imgUrl = avatarUrl || '/img/default_avatars/u.png';

  return (
    <div className={style.global}>
      {renderAvatar(imgUrl)}
      <div className="transaction-info">
        <div className="transaction-name-and-merchant">
          <strong>{name}</strong> at <strong>{merchant}</strong>
        </div>
        <div className="transaction-date-and-flags">
          <span>{date}</span>
          {flagDuplicate && <span className="duplicate-flag">Duplicate</span>}
        </div>
      </div>
      {renderAmount(amount)}
    </div>
  );
};
